import React from 'react';
import { Slider, SliderProps, makeStyles, withStyles } from '@material-ui/core';

type ColorSliderProps = {
    sliderColor: string
}

const ColorSlider: any = withStyles({
    root: {
        color: (props: ColorSliderProps) => props.sliderColor,
        height: '25em !important',
    },
    thumb: {
        height: 24,
        width: 24,
        backgroundColor: '#fff',
        border: '2px solid currentColor',
        marginTop: -8,
        marginLeft: -12,
        '&:focus, &:hover, &$active': {
            boxShadow: 'inherit',
        },
    },
    active: {},
    valueLabel: {
        left: 'calc(-50% + 4px)',
    },
    track: {
        width: '1em !important',
        borderRadius: '4em !important',
    },
    rail: {
        width: '1em !important',
        borderRadius: '4em !important',
    },
})(Slider);

export default ColorSlider;